import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { accountApi } from '../../services/accountApi';
import { ChangePasswordRequest } from '../../dtos/Accounts/index';

export function useChangePassword() {
  return useMutation({
    mutationFn: (data: ChangePasswordRequest) => accountApi.changePassword(data),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully changed password');
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to change password'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to change password'}`);
    },
  });
}
